import type { TourDefinicion } from '@/features/guia-interactiva/types/guia-interactiva.types';
import { tourInicio } from './inicio.tour';
import { tourRecetTecnologias } from './recet-tecnologias.tour';
import { tourRecetTecnologiaEditor } from './recet-tecnologia-editor.tour';
import { tourRecetTecnologiaEditorAcciones } from './recet-tecnologia-editor-acciones.tour';
import { tourRecetSecciones } from './recet-secciones.tour';
import { tourRecetReferencias } from './recet-referencias.tour';
import { tourSeguridadUsuarios } from './seguridad-usuarios.tour';
import { tourSeguridadRoles } from './seguridad-roles.tour';
import { tourSeguridadPermisos } from './seguridad-permisos.tour';
import { tourSeguridadSesiones } from './seguridad-sesiones.tour';
import { tourSeguridadOrganizaciones } from './seguridad-organizaciones.tour';
import { tourSeguridadAplicaciones } from './seguridad-aplicaciones.tour';
import { tourSeguridadSmtp } from './seguridad-smtp.tour';
import { tourNotificacionesPlantillas } from './notificaciones-plantillas.tour';
import { tourNotificacionesEnvios } from './notificaciones-envios.tour';
import { tourConfiguracionParametros } from './configuracion-parametros.tour';
import { tourEnsuassSolicitudes } from './ensuass-solicitudes.tour';

/**
 * Tours por menú, indexados por código. Cada pantalla del admin instala su
 * tour con `useTourContextual(codigo)` y se auto-dispara la primera vez que
 * el usuario entra (si cumple permisos). Al completar o cerrar se marca en
 * `toursVistos[]` del usuario y no vuelve a abrirse automáticamente.
 *
 * Los tours que declaran `bloqueanteEnPrimeraVisita: true` (hoy: Tecnologías
 * e Inicio, los menús a los que redirige el login) se disparan SIN botón X
 * ni Esc en su primera ejecución. Al relanzarlos desde el ? o el índice
 * siempre son skippable.
 */
export const TOURS: Readonly<Record<string, TourDefinicion>> = Object.freeze({
  [tourInicio.codigo]: tourInicio,
  [tourRecetTecnologias.codigo]: tourRecetTecnologias,
  [tourRecetTecnologiaEditor.codigo]: tourRecetTecnologiaEditor,
  [tourRecetTecnologiaEditorAcciones.codigo]: tourRecetTecnologiaEditorAcciones,
  [tourRecetSecciones.codigo]: tourRecetSecciones,
  [tourRecetReferencias.codigo]: tourRecetReferencias,
  [tourSeguridadUsuarios.codigo]: tourSeguridadUsuarios,
  [tourSeguridadRoles.codigo]: tourSeguridadRoles,
  [tourSeguridadPermisos.codigo]: tourSeguridadPermisos,
  [tourSeguridadSesiones.codigo]: tourSeguridadSesiones,
  [tourSeguridadOrganizaciones.codigo]: tourSeguridadOrganizaciones,
  [tourSeguridadAplicaciones.codigo]: tourSeguridadAplicaciones,
  [tourSeguridadSmtp.codigo]: tourSeguridadSmtp,
  [tourNotificacionesPlantillas.codigo]: tourNotificacionesPlantillas,
  [tourNotificacionesEnvios.codigo]: tourNotificacionesEnvios,
  [tourConfiguracionParametros.codigo]: tourConfiguracionParametros,
  [tourEnsuassSolicitudes.codigo]: tourEnsuassSolicitudes,
});

export const TOURS_LIST: readonly TourDefinicion[] = Object.values(TOURS);
